import React from 'react'

export const Dashboard: React.FC = () => {
  const stats = [
    {
      name: 'Total Assets Tracked',
      value: '2,847',
      change: '+12.5%',
      changeType: 'positive',
    },
    {
      name: 'Portfolio Value',
      value: '$45.2M',
      change: '+8.1%',
      changeType: 'positive',
    },
    {
      name: 'Risk Score',
      value: '68',
      change: '-2.3%',
      changeType: 'negative',
    },
    {
      name: 'Monthly Return',
      value: '15.3%',
      change: '+4.7%',
      changeType: 'positive',
    },
  ]

  return (
    <div 
      className="w-full max-w-none space-y-6" 
      style={{ 
        width: '100%', 
        maxWidth: 'none', 
        minWidth: '0',
        flex: '1' 
      }}
    >
      {/* Header */}
      <div style={{ width: '100%', maxWidth: 'none' }}>
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-600 mt-2">
          Investment intelligence overview and key metrics
        </p>
      </div>

      {/* Stats Grid */}
      <div 
        className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6" 
        style={{ width: '100%', maxWidth: 'none' }}
      >
        {stats.map((stat) => (
          <div
            key={stat.name}
            className="bg-white rounded-lg shadow border border-gray-200 p-6"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">{stat.name}</p>
                <p className="text-2xl font-bold text-gray-900 mt-1">{stat.value}</p>
              </div>
              <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-lg">
                <span className="text-blue-600 text-lg">📊</span>
              </div>
            </div>
            <div className="mt-4 flex items-center">
              <span
                className={`text-sm font-medium ${
                  stat.changeType === 'positive'
                    ? 'text-green-600'
                    : 'text-red-600'
                }`}
              >
                {stat.change}
              </span>
              <span className="text-sm text-gray-500 ml-2">from last month</span>
            </div>
          </div>
        ))}
      </div>

      {/* Module Cards */}
      <div className="grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Recent Asset Evaluations
          </h3>
          <div className="space-y-3">
            {['TSLA', 'NVDA', 'META', 'AAPL'].map((symbol) => (
              <div key={symbol} className="flex items-center justify-between py-2">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-xs font-medium text-blue-600">{symbol.charAt(0)}</span>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-gray-900">{symbol}</p>
                    <p className="text-xs text-gray-500">Tech Stock</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium text-green-600">
                    {Math.floor(Math.random() * 40) + 60}
                  </p>
                  <p className="text-xs text-gray-500">Score</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Active Alerts
          </h3>
          <div className="space-y-3">
            <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
              <div className="flex">
                <div className="flex-shrink-0">
                  <span className="text-yellow-400 text-lg">⚠️</span>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-yellow-800">
                    High volatility detected in Quantum sector
                  </p>
                  <p className="text-xs text-yellow-600 mt-1">2 hours ago</p>
                </div>
              </div>
            </div>
            
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <div className="flex">
                <div className="flex-shrink-0">
                  <span className="text-red-400 text-lg">🚨</span>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-red-800">
                    Hostile acquisition risk identified: NVDA
                  </p>
                  <p className="text-xs text-red-600 mt-1">4 hours ago</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}